/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

export const FilterGroup = styled.div({
  display: 'flex',
  alignItems: 'center',
  /* Account for any component that could be in the filter group (Button, <a>, FieldText, etc) */
  '> * + *': {
    marginLeft: `${gridSize() * 2}px`,
  },
  '> div': {
    minWidth: 0,
  },
});
